import { FC, HTMLAttributes } from 'react';

import styles from './Sparcles.module.scss';

type SparclesProps = HTMLAttributes<HTMLDivElement>;

export const Sparcles: FC<SparclesProps> = ({ className = '', ...props }) => {
  return (
    <div className={`${styles.sparcles} ${className}`} {...props}>
      <svg
        className={styles.sparcle1}
        id="sparcle1"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
          fill="url(#paint0_radial_633_6738)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_633_6738"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(16 16) rotate(90) scale(12 10)"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#FFE588" />
          </radialGradient>
        </defs>
      </svg>
      <svg
        className={styles.sparcle2}
        id="sparcle2"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
          fill="url(#paint0_radial_633_6738)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_633_6738"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(16 16) rotate(90) scale(12 10)"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#FFE588" />
          </radialGradient>
        </defs>
      </svg>
      <svg
        className={styles.sparcle3}
        id="sparcle3"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 4L17.5556 14.1332L26 16L17.5556 17.8668L16 28L14.4444 17.8668L6 16L14.4444 14.1332L16 4Z"
          fill="url(#paint0_radial_633_6738)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_633_6738"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(16 16) rotate(90) scale(12 10)"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#FFE588" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
};
